import { render, staticRenderFns } from "./CRMTemplate.vue?vue&type=template&id=1528c07f&scoped=true&"
import script from "./CRMTemplate.vue?vue&type=script&lang=js&"
export * from "./CRMTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CRMTemplate.vue?vue&type=style&index=0&id=1528c07f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1528c07f",
  null
  
)

export default component.exports